var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    { staticClass: "main" },
    [
      _c(
        "el-header",
        { staticClass: "head", attrs: { height: "42px" } },
        [
          _c("span", { staticClass: "ik-info-title" }, [
            _c(
              "span",
              { staticClass: "svg-container ik-info-icon" },
              [_c("svg-icon", { attrs: { "icon-class": "database" } })],
              1
            ),
            _vm._v(" 设置 "),
          ]),
          _c(
            "el-button-group",
            { staticClass: "ik-info-menu" },
            [
              _c(
                "el-button",
                {
                  staticClass: "ik-info-menu-btn",
                  attrs: { size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "ik-info-menu-btn",
                  attrs: { size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-main",
        { staticClass: "content" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("span", { staticClass: "text" }, [_vm._v("标题")]),
                  _c("el-input", {
                    attrs: { placeholder: "请输入标题" },
                    model: {
                      value: _vm.title,
                      callback: function ($$v) {
                        _vm.title = $$v
                      },
                      expression: "title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("span", { staticClass: "text" }, [_vm._v("后台地址")]),
                  _c("el-input", {
                    attrs: { placeholder: "http://......" },
                    model: {
                      value: _vm.url,
                      callback: function ($$v) {
                        _vm.url = $$v
                      },
                      expression: "url",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("span", { staticClass: "text" }, [_vm._v("测试模式:")]),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "0" },
                      model: {
                        value: _vm.model,
                        callback: function ($$v) {
                          _vm.model = $$v
                        },
                        expression: "model",
                      },
                    },
                    [_vm._v("否")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.model,
                        callback: function ($$v) {
                          _vm.model = $$v
                        },
                        expression: "model",
                      },
                    },
                    [_vm._v("是")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }